function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-copy",
  "data-name": "Icon awesome-copy",
  d: "M18.862,26.406v2.358a1.415,1.415,0,0,1-1.415,1.415H1.415A1.415,1.415,0,0,1,0,28.764V7.073A1.415,1.415,0,0,1,1.415,5.659H5.659V23.106a3.3,3.3,0,0,0,3.3,3.3Zm0-20.276V0h-9.9A1.415,1.415,0,0,0,7.545,1.415V23.106A1.415,1.415,0,0,0,8.959,24.52H24.992a1.415,1.415,0,0,0,1.415-1.415V7.545h-6.13A1.419,1.419,0,0,1,18.862,6.13ZM25.992,4.3,22.105.414A1.415,1.415,0,0,0,21.1,0h-.357V5.659h5.659V5.3a1.415,1.415,0,0,0-.414-1Z",
  fill: "#eee"
});

var SvgDocIcon = function SvgDocIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26.406,
    height: 30.179,
    viewBox: "0 0 26.406 30.179",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/doc_icon.3d7711e5.svg";
export { ForwardRef as ReactComponent };